import React from 'react';
import apiErrorModel from '../../models/apiErrorModel';
import './_ApiErrorMessage.scss';

function ApiErrorMessage({ error, onRetry, className = 'Error' }) {
  if (error == null || error === '') {
    return null;
  }

  const message = apiErrorModel.getDisplayMessage(error);
  const showRetry =
    typeof onRetry === 'function' && (error.retryable == null || error.retryable);

  return (
    <div className={`ApiErrorMessage ${className}`.trim()} role="alert">
      <p className="ApiErrorMessage-text">{message}</p>
      {showRetry ? (
        <button type="button" className="Button ApiErrorMessage-retry" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </div>
  );
}

export default ApiErrorMessage;
